import {CommonMessages} from '../common.messages';

export const MarketDataFeedsAddMessages = {
    MarketDataFeedCreationFailed: {
        key: 'MarketDataFeedCreationFailed',
        message: 'Error while processing request. Unable to create a Market Data Feed.'
    },
    MarketDataFeedCreationSucceed: {
        key: 'MarketDataFeedCreationSucceed',
        message: 'Market Data Feed is successfully created.'
    },
    MarketDataFeedBundleCreationFailed: {
        key: 'MarketDataFeedBundleCreationFailed',
        message: 'Error while processing request. Unable to create a Market Data Feed Bundle.'
    },
    MarketDataFeedBundleCreationSucceed: {
        key: 'MarketDataFeedBundleCreationSucceed',
        message: 'Market Data Feed Bundle is successfully created.'
    },
    MarketDataFeedBundleUpdateSucceed: {
        key: 'MarketDataFeedBundleUpdateSucceed',
        message: 'Market Data Feed Bundle is successfully updated.'
    },
    MarketDataFeedDeletionFailed: {
        key: 'MarketDataFeedDeletionFailed',
        message: 'Error while processing request. Unable to delete a Market Data Feed.'
    },
    CreateMarketDataFeedBundleFailedNoFeed: {
        key: 'CreateMarketDataFeedBundleFailedNoFeed',
        message: 'Error while processing request. At least 2 Market Data Feed is Required.'
    },
    CreateMarketDataFeedBundleFailedRequiredFeedOrPFE: {
        key: 'CreateMarketDataFeedBundleFailedRequiredFeedOrPFE',
        message: 'Error while processing request. At least 2 Market Data Feed or Platfrom Frontend is Required.'
    },
    MarketDataFeedDeletionSucceed: {
        key: 'MarketDataFeedDeletionSucceed',
        message: 'Market Data Feed is successfully deleted.'
    },
    MarketDataFeedUpdateFailed: {
        key: 'MarketDataFeedUpdateFailed',
        message: 'Error while processing request. Unable to update a Market Data Feed.'
    },
    MarketDataFeedBundleUpdateFailed: {
        key: 'MarketDataFeedBundleUpdateFailed',
        message: 'Error while processing request. Unable to update a Market Data Feed Bundle.'
    },
    MarketDataFeedUpdateSucceed: {
        key: 'MarketDataFeedUpdateSucceed',
        message: 'Market Data Feed is successfully updated.'
    },
    MarketDataFeedListDeletableFailed: {
        key: 'MarketDataFeedListDeletableFailed',
        message: 'Error while processing request. Unable to list deletable Market Data Feeds.'
    },
    MarketDataFeedListUnassignedFailed: {
        key: 'MarketDataFeedListUnassignedFailed',
        message: 'Error while processing request. Unable to list unassigned Market Data Feeds.'
    },
    MarketDataFeedListFailedNoUnassignedFeed: {
        key: 'MarketDataFeedListFailedNoUnassignedFeed',
        message: 'There is no unassigned Market Data Feed.'
    },
    MarketDataFeedNoDeletableData: {
        key: 'MarketDataFeedNoDeletableData',
        message: 'There are no deletable Market Data Feeds/Bundles! All of them may have been assigned to a bundle or an account.'
    },
    MarketDataFeedBundleListDeletableFailed: {
        key: 'MarketDataFeedBundleListDeletableFailed',
        message: 'Error while processing request. Unable to list deletable Market Data Feed Bundles.'
    },
    MarketDataFeedOfBundleRemoveFailed: {
        key: 'MarketDataFeedOfBundleRemoveFailed',
        message: 'The bundle must contain at least 1 feed.'
    },
    GetMarketDataFeedFailedNoSelectedId: {
        key: 'GetMarketDataFeedFailedNoSelectedId',
        message: 'The feed/bundle Id is not found.'
    },
    UpdateMarketDataFeedBundleFailed: {
        key: 'UpdateMarketDataFeedBundleFailed',
        message: 'Error while processing request. Unable to update a Bundle.'
    },
    MarketDataFeedOfBundleRemoveFailedNeedToSelectMinFeed: {
        key: 'MarketDataFeedOfBundleRemoveFailedNeedToSelectMinFeed',
        message: 'At least 1 Feed must be selected to remove.'
    },
    MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeed: {
        key: 'MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeed',
        message: 'At least 1 Feed must be stay in Bundle.'
    },
    MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeedOrPFE: {
        key: 'MarketDataFeedOfBundleRemoveFailedNeedToStayMinFeedOrPFE',
        message: 'At least 1 Feed/Platform Frontend must be stay in Bundle.'
    },
    MarketDataFeedOfBundleRemoveFailedNoAssignedFeed: {
        key: 'MarketDataFeedOfBundleRemoveFailedNoAssignedFeed',
        message: 'There is no feed assigned to bundle.'
    },
    MarketDataFeedListPortalsFailed: {
        key: 'MarketDataFeedListPortalsFailed',
        message: 'Error while processing request. Unable to list portals.'
    },
    ...CommonMessages
};
